import QuotationTopBarV2 from "./QuotationTopBarV2";

export default QuotationTopBarV2;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/index.js